import callApi from "../../Api";
import moment from 'moment';
import { range} from 'lodash';
import { ToastMessage, SUCCESS, ERROR } from "../../common/ToastMessage";
export const OPEN_LOADER = "OPEN_LOADER";
export const CLOSE_LOADER = "CLOSE_LOADER";
export const CREATE_NOTIFICATION = "CREATE_NOTIFICATION"
export const NOTIFICATION_LIST = "NOTIFICATION_LIST"
export const STUDENTS_GROUP_LIST ="STUDENTS_GROUP_LIST"
export const RESET_NOTIFICATION_LIST = "RESET_NOTIFICATION_LIST";
export const GET_MSG_TEMPLATE = "GET_MSG_TEMPLATE"
export const openLoader = (data) => ({
  type: OPEN_LOADER,
  payload: true,
});
export const closeLoader = (data) => ({
  type: CLOSE_LOADER,
  payload: false,
});

export const createNotificationAction = (reqObj) => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.post("notification/create",reqObj);
    if (data.data.success) {
      dispatch(closeLoader());
      dispatch({
        type: CREATE_NOTIFICATION,
        payload: data.data.data,
      });
      ToastMessage(SUCCESS, data.data.message);
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};

export const formatNotificationList = (data)=>{
  const notificationData = data.filter(obj=>{
    obj.createdAt = moment(obj.createdAt).format("YYYY-MM-DD HH:MM:SS");
    obj.BranchName = obj.Branch ? obj.Branch.name : "-";
    obj.ClassGroupName = obj.ClassGroup ? obj.ClassGroup.name : "-";
    obj.ClassRoomName = obj.ClassRoom ? obj.ClassRoom.name : "-";
    obj.StudentName = obj.Student ? (obj.Student.User.firstName + " " + obj.Student.User.lastName ) : "-";
    obj.notificationType = obj.NotificationType ? (obj.NotificationType.name ) : "-";
    return obj;
  })
  return notificationData;
}

export const listAction = (reqObj) => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.get("notification/list",{params: reqObj});
    if (data.data.success) {
      dispatch(closeLoader());
      console.log(data.data)
      const notificationData = formatNotificationList(data.data.data.rows);
      dispatch({
        type: NOTIFICATION_LIST,
        payload: {
          notificationData,
          totalItems: data.data.data.totalItems,
          totalPages: data.data.data.totalPages,
          currentPage: data.data.data.currentPage
        },
      });
      // ToastMessage(SUCCESS, data.data.message);
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};

export const studentGroupAction = (reqObj) => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.get("notification/studentGroup",{params: {...reqObj,year: moment().format("YYYY")}});
    if (data.data.success) {
      dispatch(closeLoader());
      const studentsData = data.data.data.filter(obj=>{
        obj.label = (obj.Student.User.firstName +" "+ obj.Student.User.lastName)
        obj.value = obj.Student.id
        return obj;
      })
      // const studentsData = range(1,500).map(obj=>{
      //   return {
      //     label:  obj,
      //     value : obj
      //   };
      // })
      dispatch({
        type: STUDENTS_GROUP_LIST,
        payload: studentsData,
      });
      // ToastMessage(SUCCESS, data.data.message);
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};

export const formatStudentNotifications = (data)=>{
  const notificationData = data.filter(obj=>{
    if(obj.BranchNotificationStudent){
      obj.content = obj.BranchNotificationStudent.message
    }
    if(obj.ClassGroupNotificationStudent){
      obj.content = obj.ClassGroupNotificationStudent.message
    }
    if(obj.ClassRoomNotificationStudent){
      obj.content = obj.ClassRoomNotificationStudent.message
    }
    obj.createdAt = moment(obj.createdAt).format("YYYY-MM-DD HH:MM:SS a")
    obj.notification_type = obj.NotificationType.name;
    return obj;
  })
  return notificationData;
}


export const studentNofificationAction = (reqObj) => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.get("student/notifications",{params: reqObj});
    if (data.data.success) {
      dispatch(closeLoader());
      const notificationData = formatStudentNotifications(data.data.data.rows);
      console.log(notificationData)
      dispatch({
        type: NOTIFICATION_LIST,
        payload: {
          notificationData,
          totalItems: data.data.data.totalItems,
          totalPages: data.data.data.totalPages,
          currentPage: data.data.data.currentPage
        },
      });
      // ToastMessage(SUCCESS, data.data.message);
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};
export const resetNotificationAction = (reqObj) => async (dispatch) => {
  dispatch({
    type: RESET_NOTIFICATION_LIST,
  payload: [],
  })
}
export const smsTemplateAction = (reqObj) => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.get("notification/sms_content",{params: reqObj});
    if (data.data.success) {
      dispatch(closeLoader());
      
      console.log(data.data.data)
      dispatch({
        type: GET_MSG_TEMPLATE,
        payload: data.data.data.message,
      });
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};